var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MdDialog',{staticClass:"csr-shipping-dialog csr-md-dialog-v2",attrs:{"title":_setup.popUpTaxTitle,"visible":_setup.visible,"append-to-body":""},on:{"close":_setup.cancel}},[_c('div',{staticClass:"csr-shipping-dialog-content",domProps:{"innerHTML":_vm._s(_setup.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }